import AccountAPI from '../../api/account';

export const state = {
  keys: {},
  isLoading: false,
  isLoaded: false,
  error: null,
};

export const getters = {
  getCacheKey: _state => modelName => {
    return _state.keys[modelName];
  },
  isLoaded: _state => {
    return _state.isLoaded;
  },
  isLoading: _state => {
    return _state.isLoading;
  },
};

export const actions = {
  // Load cache keys once and store them
  async load({ commit, state: storeState }) {
    // Prevent duplicate calls if already loading or loaded
    if (storeState.isLoading || storeState.isLoaded) {
      return storeState.keys;
    }

    commit('SET_LOADING', true);
    try {
      const keys = await AccountAPI.getCacheKeys();
      commit('SET_CACHE_KEYS', keys);
      commit('SET_LOADED', true);
      return keys;
    } catch (error) {
      commit('SET_ERROR', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // Update specific cache key when revalidation happens
  updateKey({ commit }, { modelName, value }) {
    commit('UPDATE_KEY', { modelName, value });
  },

  // Clear all cache keys (e.g., on account switch)
  clear({ commit }) {
    commit('CLEAR');
  },
};

export const mutations = {
  SET_CACHE_KEYS(_state, keys) {
    _state.keys = keys;
  },

  UPDATE_KEY(_state, { modelName, value }) {
    _state.keys = {
      ..._state.keys,
      [modelName]: value,
    };
  },

  SET_LOADING(_state, value) {
    _state.isLoading = value;
  },

  SET_LOADED(_state, value) {
    _state.isLoaded = value;
  },

  SET_ERROR(_state, error) {
    _state.error = error;
  },

  CLEAR(_state) {
    _state.keys = {};
    _state.isLoading = false;
    _state.isLoaded = false;
    _state.error = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
